export default "__VITE_ASSET__BGaoLOh1__"